import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import classNames from 'classnames/bind';
import { TextBase } from "../../../../internal/TextBase";
import { getMethodsForTestId } from "../../../../utils/getMethodsForTestId";
import styles from './Favorites.css';
var cx = classNames.bind(styles);
export var Favorites = function Favorites(_ref) {
  var items = _ref.items,
      separatedItems = _ref.separatedItems,
      namespace = _ref.namespace;

  var _getMethodsForTestId = getMethodsForTestId(namespace, 'favorites'),
      getTestId = _getMethodsForTestId.getTestId,
      getNamespace = _getMethodsForTestId.getNamespace;

  return /*#__PURE__*/React.createElement("div", _extends({
    className: cx('root', {
      shape: !separatedItems,
      center: separatedItems
    })
  }, getTestId()), /*#__PURE__*/React.createElement("div", {
    className: cx('inner')
  }, items === null || items === void 0 ? void 0 : items.map(function (_ref2, index) {
    var href = _ref2.href,
        icon = _ref2.icon,
        subtitle = _ref2.subtitle,
        title = _ref2.title,
        target = _ref2.target,
        props = _ref2.props;
    return /*#__PURE__*/React.createElement("a", _extends({}, getTestId(index.toString(), 'link'), props, {
      // eslint-disable-next-line react/no-array-index-key
      key: "favorite_".concat(index),
      className: cx('item', {
        shape: separatedItems
      }),
      href: href,
      target: target
    }), icon, /*#__PURE__*/React.createElement("div", {
      className: cx('caption')
    }, /*#__PURE__*/React.createElement(TextBase, {
      as: "span",
      weight: "semibold",
      namespace: getNamespace('title')
    }, title), /*#__PURE__*/React.createElement(TextBase, {
      as: "span",
      color: "N100",
      size: "s",
      namespace: getNamespace('subtitle')
    }, subtitle)));
  })));
};